$(function () {
    const DEFAULTS = {
        width: 800,
        height: 600,
        scrollbars: "yes",
        namePrefix: "PopupWindow",
        featuresExtra: "resizable=yes,toolbar=no,menubar=no,location=no,status=no"
    };

    function uid(len = 10) {
        // crypto 지원 시 우선 사용
        if (window.crypto?.getRandomValues) {
            const arr = new Uint8Array(len);
            crypto.getRandomValues(arr);
            return Array.from(arr, b => (b % 36).toString(36)).join("");
        }
        // fallback
        return Math.random().toString(36).slice(2, 2 + len);
    }

    function toInt(v, fallback) {
        const n = parseInt(v, 10);
        return Number.isFinite(n) && n > 0 ? n : fallback;
    }

    function centerPopupRect(width, height) {
        // 브라우저가 위치한 모니터 기준 중앙(멀티 모니터 대응)
        const dualScreenLeft = window.screenLeft ?? window.screenX ?? 0;
        const dualScreenTop = window.screenTop ?? window.screenY ?? 0;

        const winWidth = window.innerWidth || document.documentElement.clientWidth || screen.width;
        const winHeight = window.innerHeight || document.documentElement.clientHeight || screen.height;

        const left = Math.round(dualScreenLeft + (winWidth - width) / 2);
        const top = Math.round(dualScreenTop + (winHeight - height) / 2);

        return { left: Math.max(left, 0), top: Math.max(top, 0) };
    }

    $("body").on("click", "a.popup", function (e) {
        e.preventDefault();

        const $a = $(e.currentTarget);

        const href = $a.attr("href");
        if (!href || href === "#") return;

        // data-popup-* 우선, 없으면 기본값
        const width = toInt($a.data("popup-width"), DEFAULTS.width);
        const height = toInt($a.data("popup-height"), DEFAULTS.height);
        const scrollbars = ($a.data("popup-scrollbars") ?? DEFAULTS.scrollbars).toString();

        const { left, top } = centerPopupRect(width, height);

        // 창 이름: data-popup-name이 있으면 재사용(같은 창에 열리게)
        // 없으면 uid 붙여서 항상 새 창
        const name = ($a.data("popup-name") ?? (DEFAULTS.namePrefix + uid())).toString();

        const features = [
            `width=${width}`,
            `height=${height}`,
            `left=${left}`,
            `top=${top}`,
            `scrollbars=${scrollbars}`,
            DEFAULTS.featuresExtra,
        ].join(",");

        const w = window.open(href, name, features);

        if (!w) {
            // 팝업 차단 대응
            alert("팝업이 차단되었습니다. 브라우저의 팝업 차단을 해제한 뒤 다시 시도해 주세요.");
            return;
        }

        try {
            w.focus();
        } catch (_) {}
    });

    // (선택) 준비중 링크 처리
    // $("body").on("click", "a[href='#dev']", function (e) {
    //   e.preventDefault();
    //   alert("기능 준비중입니다.");
    // });
});